import React from 'react';
import {
    Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography, Grid, Box, Card,
    Avatar, Chip, CircularProgress
} from '@mui/material';
import SoccerIcon from '@mui/icons-material/SportsSoccer';
import SportsSoccerIcon from '@mui/icons-material/SportsSoccer';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import CropSquareIcon from '@mui/icons-material/CropSquare';
import StopIcon from '@mui/icons-material/Stop';
import EmojiEventsIcon from '@mui/icons-material/EmojiEvents';

const PartitaDetailDialog = ({ 
    open, 
    onClose, 
    selectedPartita, 
    goalPartita, 
    loadingGoal,
    cartellinoPartita,
    loadingCartellini,
    mvpPartita,
    loadingMvp,
    onEdit 
}) => {
    if (!selectedPartita) return null;

    return (
        <Dialog
            open={open}
            onClose={onClose}
            maxWidth="lg"
            fullWidth
        >
            <DialogTitle sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                <SoccerIcon sx={{ fontSize: 40, color: '#4caf50' }} />
                <Box>
                    <Typography variant="h6">
                        {selectedPartita?.teamCasaNome || 'Casa'} vs {selectedPartita?.teamOspiteNome || 'Ospite'}
                    </Typography>
                    <Typography variant="caption" color="text.secondary">
                        ID: {selectedPartita?.partitaId} • {selectedPartita?.giornataNome} • {selectedPartita?.legaNome}
                    </Typography>
                </Box>
                {selectedPartita?.flDisputata && (
                    <Box sx={{ ml: 'auto', textAlign: 'center' }}>
                        <Typography variant="h4" sx={{ fontWeight: 700, color: '#2e7d32' }}>
                            {selectedPartita?.goalCasa || 0} - {selectedPartita?.goalOspite || 0}
                        </Typography>
                        {selectedPartita?.risultatoUfficiale && (
                            <Chip label="Risultato Ufficiale" size="small" color="success" />
                        )}
                    </Box>
                )}
            </DialogTitle>

            <DialogContent>
                <Grid container spacing={3}>
                    {/* Squadre */}
                    <Grid item xs={12} md={6}>
                        <Card sx={{ p: 2 }}>
                            <Typography variant="subtitle2" gutterBottom>
                                Squadre
                            </Typography>
                            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                                {/* Casa */}
                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, p: 1, bgcolor: '#e8f5e8', borderRadius: 1 }}>
                                    <Avatar src={selectedPartita.teamCasaFoto} sx={{ width: 40, height: 40 }}>
                                        {selectedPartita.teamCasaNome?.charAt(0)}
                                    </Avatar>
                                    <Box sx={{ flex: 1 }}>
                                        <Typography variant="body1" sx={{ fontWeight: 600 }}>
                                            {selectedPartita.teamCasaNome || 'Casa'}
                                        </Typography>
                                        <Typography variant="caption" color="text.secondary">
                                            Casa • ID: {selectedPartita.teamCasaId}
                                        </Typography>
                                    </Box>
                                    {selectedPartita.flDisputata && (
                                        <Typography variant="h5" sx={{ fontWeight: 700, color: '#2e7d32' }}>
                                            {selectedPartita.goalCasa || 0}
                                        </Typography>
                                    )}
                                </Box>

                                {/* Ospite */}
                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, p: 1, bgcolor: '#e3f2fd', borderRadius: 1 }}>
                                    <Avatar src={selectedPartita.teamOspiteFoto} sx={{ width: 40, height: 40 }}>
                                        {selectedPartita.teamOspiteNome?.charAt(0)}
                                    </Avatar>
                                    <Box sx={{ flex: 1 }}>
                                        <Typography variant="body1" sx={{ fontWeight: 600 }}>
                                            {selectedPartita.teamOspiteNome || 'Ospite'}
                                        </Typography>
                                        <Typography variant="caption" color="text.secondary">
                                            Ospite • ID: {selectedPartita.teamOspiteId}
                                        </Typography>
                                    </Box>
                                    {selectedPartita.flDisputata && (
                                        <Typography variant="h5" sx={{ fontWeight: 700, color: '#2e7d32' }}>
                                            {selectedPartita.goalOspite || 0}
                                        </Typography>
                                    )}
                                </Box>
                            </Box>
                        </Card>
                    </Grid>

                    {/* Dettagli Partita */}
                    <Grid item xs={12} md={6}>
                        <Card sx={{ p: 2 }}>
                            <Typography variant="subtitle2" gutterBottom>
                                Dettagli Partita
                            </Typography>
                            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                                <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                                    <Typography variant="body2" color="text.secondary">Data:</Typography>
                                    <Typography variant="body2" sx={{ fontWeight: 500 }}>
                                        {selectedPartita.data ? new Date(selectedPartita.data).toLocaleDateString('it-IT') : 'N/A'}
                                    </Typography>
                                </Box>
                                <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                                    <Typography variant="body2" color="text.secondary">Orario:</Typography>
                                    <Typography variant="body2" sx={{ fontWeight: 500 }}>
                                        {selectedPartita.orario || 'N/A'}
                                    </Typography>
                                </Box>
                                <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                                    <Typography variant="body2" color="text.secondary">Luogo:</Typography>
                                    <Typography variant="body2" sx={{ fontWeight: 500 }}>
                                        {selectedPartita.luogo || 'N/A'}
                                    </Typography>
                                </Box>
                                <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                                    <Typography variant="body2" color="text.secondary">Giornata:</Typography>
                                    <Typography variant="body2" sx={{ fontWeight: 500 }}>
                                        {selectedPartita.giornataNome || 'N/A'}
                                    </Typography>
                                </Box>
                                <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                                    <Typography variant="body2" color="text.secondary">Lega:</Typography>
                                    <Typography variant="body2" sx={{ fontWeight: 500 }}>
                                        {selectedPartita.legaNome || 'N/A'}
                                    </Typography>
                                </Box>
                                <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                                    <Typography variant="body2" color="text.secondary">Stagione:</Typography>
                                    <Typography variant="body2" sx={{ fontWeight: 500 }}>
                                        {selectedPartita.stagionaNome || 'N/A'}
                                    </Typography>
                                </Box>
                                {selectedPartita.note && (
                                    <Box sx={{ mt: 1 }}>
                                        <Typography variant="body2" color="text.secondary">Note:</Typography>
                                        <Typography variant="body2" sx={{ fontWeight: 500, mt: 0.5 }}>
                                            {selectedPartita.note}
                                        </Typography>
                                    </Box>
                                )}
                            </Box>
                        </Card>
                    </Grid>

                    {/* Sezione Goal */}
                    {selectedPartita?.flDisputata && (
                        <Grid item xs={12}>
                            <Card sx={{ p: 2 }}>
                                <Typography variant="subtitle2" gutterBottom sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                    <SportsSoccerIcon sx={{ fontSize: 20, color: '#4caf50' }} />
                                    Goal della Partita
                                    {loadingGoal && <CircularProgress size={16} />}
                                </Typography>
                                
                                {loadingGoal ? (
                                    <Box sx={{ display: 'flex', justifyContent: 'center', p: 2 }}>
                                        <CircularProgress size={24} />
                                    </Box>
                                ) : goalPartita.length > 0 ? (
                                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1, mt: 1 }}>
                                        {goalPartita.map((goal, index) => (
                                            <Box 
                                                key={goal.id} 
                                                sx={{ 
                                                    display: 'flex', 
                                                    alignItems: 'center', 
                                                    gap: 2, 
                                                    p: 1.5, 
                                                    bgcolor: index % 2 === 0 ? '#f8f9fa' : 'transparent',
                                                    borderRadius: 1,
                                                    border: '1px solid #e0e0e0'
                                                }}
                                            >
                                                <Box sx={{ 
                                                    display: 'flex', 
                                                    alignItems: 'center', 
                                                    gap: 1,
                                                    minWidth: 80
                                                }}>
                                                    <AccessTimeIcon sx={{ fontSize: 16, color: '#666' }} />
                                                    <Typography variant="body2" sx={{ fontWeight: 600 }}>
                                                        {goal.minuto}'
                                                    </Typography>
                                                </Box>
                                                
                                                <SportsSoccerIcon sx={{ fontSize: 18, color: '#4caf50' }} />
                                                
                                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, flex: 1 }}>
                                                    <Avatar 
                                                        src={goal.playerFoto} 
                                                        sx={{ width: 32, height: 32 }}
                                                    >
                                                        {goal.playerName ? goal.playerName.charAt(0).toUpperCase() : '?'}
                                                    </Avatar>
                                                    <Box sx={{ flex: 1 }}>
                                                        <Typography variant="body2" sx={{ fontWeight: 500 }}>
                                                            {goal.playerName || `Giocatore ${goal.playerId}`}
                                                        </Typography>
                                                        {goal.playerTeam && (
                                                            <Typography variant="caption" color="text.secondary" sx={{ display: 'block' }}>
                                                                {goal.playerTeam}
                                                            </Typography>
                                                        )}
                                                        {goal.note && (
                                                            <Typography variant="caption" color="text.secondary" sx={{ display: 'block', fontStyle: 'italic' }}>
                                                                💬 {goal.note}
                                                            </Typography>
                                                        )}
                                                    </Box>
                                                </Box>
                                                
                                                <Box sx={{ display: 'flex', gap: 1 }}>
                                                    {goal.flAnnullato ? (
                                                        <Chip 
                                                            label="Annullato" 
                                                            size="small" 
                                                            color="error" 
                                                            variant="outlined"
                                                        />
                                                    ) : (
                                                        <Chip 
                                                            label="Valido" 
                                                            size="small" 
                                                            color="success" 
                                                            variant="outlined"
                                                        />
                                                    )}
                                                    {!goal.flVisibile && (
                                                        <Chip 
                                                            label="Nascosto" 
                                                            size="small" 
                                                            color="warning" 
                                                            variant="outlined"
                                                        />
                                                    )}
                                                </Box>
                                            </Box>
                                        ))}
                                    </Box>
                                ) : (
                                    <Typography variant="body2" color="text.secondary" sx={{ textAlign: 'center', p: 2 }}>
                                        Nessun goal registrato per questa partita
                                    </Typography>
                                )}
                            </Card>
                        </Grid>
                    )}

                    {/* Sezione Cartellini */}
                    {selectedPartita?.flDisputata && (
                        <Grid item xs={12}>
                            <Card sx={{ p: 2 }}>
                                <Typography variant="subtitle2" gutterBottom sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                    <CropSquareIcon sx={{ fontSize: 20, color: '#ffc107' }} />
                                    Cartellini della Partita
                                    {loadingCartellini && <CircularProgress size={16} />}
                                </Typography>
                                
                                {loadingCartellini ? (
                                    <Box sx={{ display: 'flex', justifyContent: 'center', p: 2 }}>
                                        <CircularProgress size={24} />
                                    </Box>
                                ) : cartellinoPartita.length > 0 ? (
                                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1, mt: 1 }}>
                                        {cartellinoPartita.map((cartellino, index) => (
                                            <Box 
                                                key={cartellino.id} 
                                                sx={{ 
                                                    display: 'flex', 
                                                    alignItems: 'center', 
                                                    gap: 2, 
                                                    p: 1.5, 
                                                    bgcolor: index % 2 === 0 ? '#fff8e1' : 'transparent',
                                                    borderRadius: 1,
                                                    border: '1px solid #e0e0e0'
                                                }}
                                            >
                                                <Box sx={{ 
                                                    display: 'flex', 
                                                    alignItems: 'center', 
                                                    gap: 1,
                                                    minWidth: 80
                                                }}>
                                                    <AccessTimeIcon sx={{ fontSize: 16, color: '#666' }} />
                                                    <Typography variant="body2" sx={{ fontWeight: 600 }}>
                                                        {cartellino.minuto}'
                                                    </Typography>
                                                </Box>
                                                
                                                {/* Icona cartellino giallo o rosso */}
                                                {cartellino.tipoCartellino === 'giallo' ? (
                                                    <CropSquareIcon sx={{ fontSize: 18, color: '#ffc107' }} />
                                                ) : cartellino.tipoCartellino === 'rosso' ? (
                                                    <StopIcon sx={{ fontSize: 18, color: '#f44336' }} />
                                                ) : (
                                                    <CropSquareIcon sx={{ fontSize: 18, color: '#9e9e9e' }} />
                                                )}
                                                
                                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, flex: 1 }}>
                                                    <Avatar 
                                                        src={cartellino.playerFoto} 
                                                        sx={{ width: 32, height: 32 }}
                                                    >
                                                        {cartellino.playerName ? cartellino.playerName.charAt(0).toUpperCase() : '?'}
                                                    </Avatar>
                                                    <Box sx={{ flex: 1 }}>
                                                        <Typography variant="body2" sx={{ fontWeight: 500 }}>
                                                            {cartellino.playerName || `Giocatore ${cartellino.playerId}`}
                                                        </Typography>
                                                        {cartellino.playerTeam && (
                                                            <Typography variant="caption" color="text.secondary" sx={{ display: 'block' }}>
                                                                {cartellino.playerTeam}
                                                            </Typography>
                                                        )}
                                                        {cartellino.note && (
                                                            <Typography variant="caption" color="text.secondary" sx={{ display: 'block', fontStyle: 'italic' }}>
                                                                💬 {cartellino.note}
                                                            </Typography>
                                                        )}
                                                    </Box>
                                                </Box>
                                                
                                                <Box sx={{ display: 'flex', gap: 1 }}>
                                                    {/* Chip tipo cartellino */}
                                                    <Chip 
                                                        label={cartellino.tipoCartellinoNome || cartellino.tipoCartellino || 'Altro'}
                                                        size="small" 
                                                        sx={{
                                                            bgcolor: cartellino.tipoCartellino?.includes('giallo') ? '#fff3c4' : cartellino.tipoCartellino?.includes('rosso') ? '#ffebee' : '#f5f5f5',
                                                            color: cartellino.tipoCartellino?.includes('giallo') ? '#f57c00' : cartellino.tipoCartellino?.includes('rosso') ? '#d32f2f' : '#666'
                                                        }}
                                                    />
                                                    
                                                    {cartellino.flAnnullato ? (
                                                        <Chip 
                                                            label="Annullato" 
                                                            size="small" 
                                                            color="error" 
                                                            variant="outlined"
                                                        />
                                                    ) : (
                                                        <Chip 
                                                            label="Valido" 
                                                            size="small" 
                                                            color="success" 
                                                            variant="outlined"
                                                        />
                                                    )}
                                                    {!cartellino.flVisibile && (
                                                        <Chip 
                                                            label="Nascosto" 
                                                            size="small" 
                                                            color="warning" 
                                                            variant="outlined"
                                                        />
                                                    )}
                                                </Box>
                                            </Box>
                                        ))}
                                    </Box>
                                ) : (
                                    <Typography variant="body2" color="text.secondary" sx={{ textAlign: 'center', p: 2 }}>
                                        Nessun cartellino registrato per questa partita
                                    </Typography>
                                )}
                            </Card>
                        </Grid>
                    )}

                    {/* Sezione MVP */}
                    {selectedPartita?.flDisputata && (
                        <Grid item xs={12}>
                            <Card sx={{ p: 2 }}>
                                <Typography variant="subtitle2" gutterBottom sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                    <EmojiEventsIcon sx={{ fontSize: 20, color: '#ffd700' }} />
                                    MVP della Partita
                                    {loadingMvp && <CircularProgress size={16} />}
                                </Typography>
                                
                                {loadingMvp ? (
                                    <Box sx={{ display: 'flex', justifyContent: 'center', p: 2 }}>
                                        <CircularProgress size={24} />
                                    </Box>
                                ) : mvpPartita.length > 0 ? (
                                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1, mt: 1 }}>
                                        {mvpPartita.map((mvp, index) => (
                                            <Box 
                                                key={mvp.id} 
                                                sx={{ 
                                                    display: 'flex', 
                                                    alignItems: 'center', 
                                                    gap: 2, 
                                                    p: 1.5, 
                                                    bgcolor: index % 2 === 0 ? '#fffbf0' : 'transparent',
                                                    borderRadius: 1,
                                                    border: '2px solid #ffd700',
                                                    boxShadow: '0 2px 4px rgba(255, 215, 0, 0.2)'
                                                }}
                                            >
                                                <EmojiEventsIcon sx={{ fontSize: 24, color: '#ffd700' }} />
                                                
                                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, flex: 1 }}>
                                                    <Avatar 
                                                        src={mvp.playerFoto} 
                                                        sx={{ 
                                                            width: 40, 
                                                            height: 40,
                                                            border: '2px solid #ffd700'
                                                        }}
                                                    >
                                                        {mvp.playerName ? mvp.playerName.charAt(0).toUpperCase() : '?'}
                                                    </Avatar>
                                                    <Box sx={{ flex: 1 }}>
                                                        <Typography variant="body1" sx={{ fontWeight: 600, color: '#b8860b' }}>
                                                            🏆 {mvp.playerName || `Giocatore ${mvp.playerId}`}
                                                        </Typography>
                                                        {mvp.playerTeam && (
                                                            <Typography variant="caption" color="text.secondary" sx={{ display: 'block' }}>
                                                                {mvp.playerTeam}
                                                            </Typography>
                                                        )}
                                                        {mvp.note && (
                                                            <Typography variant="caption" color="text.secondary" sx={{ display: 'block', fontStyle: 'italic' }}>
                                                                💬 {mvp.note}
                                                            </Typography>
                                                        )}
                                                    </Box>
                                                </Box>
                                                
                                                <Box sx={{ display: 'flex', gap: 1 }}>
                                                    <Chip 
                                                        label="MVP" 
                                                        size="small" 
                                                        sx={{
                                                            bgcolor: '#fff8dc',
                                                            color: '#b8860b',
                                                            fontWeight: 600,
                                                            border: '1px solid #ffd700'
                                                        }}
                                                    />
                                                    
                                                    {mvp.flAnnullato ? (
                                                        <Chip 
                                                            label="Annullato" 
                                                            size="small" 
                                                            color="error" 
                                                            variant="outlined"
                                                        />
                                                    ) : (
                                                        <Chip 
                                                            label="Valido" 
                                                            size="small" 
                                                            color="success" 
                                                            variant="outlined"
                                                        />
                                                    )}
                                                    {!mvp.flVisibile && (
                                                        <Chip 
                                                            label="Nascosto" 
                                                            size="small" 
                                                            color="warning" 
                                                            variant="outlined"
                                                        />
                                                    )}
                                                </Box>
                                            </Box>
                                        ))}
                                    </Box>
                                ) : (
                                    <Typography variant="body2" color="text.secondary" sx={{ textAlign: 'center', p: 2 }}>
                                        Nessun MVP assegnato per questa partita
                                    </Typography>
                                )}
                            </Card>
                        </Grid>
                    )}
                </Grid>
            </DialogContent>

            <DialogActions>
                <Button onClick={onClose}>
                    Chiudi
                </Button>
                <Button
                    variant="contained"
                    onClick={() => {
                        onEdit(selectedPartita);
                        onClose();
                    }}
                >
                    Modifica
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default PartitaDetailDialog;
